import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import {Button} from "reactstrap";
import TextField from "@material-ui/core/TextField";
import UniversalModalOverride from "components/UniversalModalOverride";


// const breadcrumbsStatic = [
// 	{
// 		name: 'Dashboard',
// 		url: '/',
// 		icon: 'dashboard',
// 	},
// ];

class Dashboard extends Framework.Components.View {
	static defaultProps = {
		locations: [],
	}

	constructor(props) {
		super(props);
		this.state.pawn_ticket = '';
		this.state.code = null;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevProps.scannedCode !== this.props.scannedCode && this.props.scannedCode) {
			this.setState({
				code: this.props.scannedCode
			}, () => {
				this.toggle('modalProduct')();
			});
		}
	}

	handleDataChange = event => {
		this.setState({[event.target.name]: event.target.value});
	};

	handleSendClick = () => {
		localStorage.setItem('pawn_search', this.state.pawn_ticket);
		this.props.history.push(`/acquisitions/pawns#${this.state.pawn_ticket}`);
	}

	render() {
		return (
			<div className="container-fluid">
				{this.props.rootState.hasPawnModule &&
					<Framework.Components.PageBar history={this.props.history}>
						<div style={{height: "38px"}}>
							<div className="d-flex" style={{width: '300px', maxWidth: '300px'}}>
								<div className="flex-grow-1" style={{height: '38px', paddingTop: '3px', backgroundColor: 'white'}}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pawn_ticket"
										label="Loan # / Pawn Ticket Search"
										value={this.state.pawn_ticket}
										onChange={this.handleDataChange}
									/>
								</div>
								<div style={{height: '38px', paddingTop: '2px', marginLeft: '1px'}} className="mr-auto">
									<Button
										className={'btn-block green-meadow'}
										onClick={this.handleSendClick}
									>Search
									</Button>
								</div>
							</div>
						</div>
					</Framework.Components.PageBar>
				}
				{
					this.props.locations.filter(
						/** @type {Locations_Object} location **/
						location => !location.archived).map((location) =>
						<Objects.Dashboard
							key={location.pkey}
							parent={location.pkey}
							parent_binary_id={location.binary_id}
							location={location}
							history={this.props.history}
							locations={this.props.locations}
							states={this.props.states}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
						/>
					)
				}

				<UniversalModalOverride
					name={"Product"}
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					id={this.state.code ? this.state.code.barcode : null}
					objectProps={{
						params: {
							id: this.state.code ? (this.state.code.prefix + '-' + this.state.code.barcode) : null
						}
					}}
					object={Objects.ProductUpdate}
					toggle={this.state['modalProduct']}
					reportClose={this.reportClose('modalProduct')}
					size={"xl"}
				/>
			</div>
		);
	}
}

export default Framework.Components.withRootState(Dashboard);


